import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89248c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "header",
  class: "header"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "search" }
const _hoisted_4 = {
  ref: "catchPhrase",
  class: "catch-phrase"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Global Leader,", -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "현대중공업", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("img", {
          class: "img-logo",
          src: $setup.logoPath,
          alt: "",
          onClick: $setup.scrollToTop
        }, null, 8 /* PROPS */, _hoisted_2)
      ], 512 /* NEED_PATCH */),
      ($setup.shouldFixSearchInput)
        ? (_openBlock(), _createBlock($setup["SearchInput"], {
            key: 0,
            name: "searchInput",
            fixed: $setup.shouldFixSearchInput,
            readonly: true,
            emphasis: true,
            onOnClickSearchInput: $setup.goToSearch
          }, null, 8 /* PROPS */, ["fixed"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        ref: "container",
        class: "container",
        onScroll: $setup.onScrollEvent
      }, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              ref: "catchPhraseFirst",
              class: _normalizeClass(["catch-phrase--first", { hide: $setup.shouldHideCatchPhraseFirst }])
            }, [..._hoisted_6], 2 /* CLASS */),
            _createElementVNode("span", {
              ref: "catchPhraseSecond",
              class: _normalizeClass(["catch-phrase--second", { hide: $setup.shouldHideCatchPhraseSecond }])
            }, [
              _createTextVNode(" 미래를 개척하는 "),
              _hoisted_7
            ], 2 /* CLASS */)
          ], 512 /* NEED_PATCH */),
          (!$setup.shouldFixSearchInput)
            ? (_openBlock(), _createBlock($setup["SearchInput"], {
                key: 0,
                name: "searchInput",
                fixed: $setup.shouldFixSearchInput,
                readonly: true,
                emphasis: true,
                onOnClickSearchInput: $setup.goToSearch
              }, null, 8 /* PROPS */, ["fixed"]))
            : _createCommentVNode("v-if", true)
        ])
      ], 544 /* NEED_HYDRATION, NEED_PATCH */)
    ]),
    _: 1 /* STABLE */
  }))
}